import React, {FunctionComponent} from "react";
import {Box, Card, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import Dialog from "../../../../../../components/base/dialog";
import Button from "../../../../../../components/base/button/button";
import {DroppedVendorDistribution} from "../planning-draft";

export interface PurchasePlanningRemovedVendorsDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    groups: DroppedVendorDistribution[];
}

const PurchasePlanningRemovedVendorsDialog: FunctionComponent<PurchasePlanningRemovedVendorsDialogProps> = (props) => {
    const {t} = useTranslation('views', {keyPrefix: 'app-specific.purchase-planning-details'});

    return (
        <Dialog
            open={props.open}
            setOpen={props.setOpen}
            maxWidth={'sm'}
            fullWidth
            className={'bound-dialog'}
        >
            <DialogTitle component={'div'}>
                <Typography variant={'h6'} sx={{p: 2}}>{t($ => $.removedVendorsTitle)}</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 1, p: 2}}>
                    <Typography variant={'body2'} color={'text.primary'}>{t($ => $.removedVendorsDescription)}</Typography>
                    <Typography variant={'body2'} color={'text.secondary'}>{t($ => $.removedVendorsExplanation)}</Typography>
                    {props.groups.map(group => (
                        <Card
                            key={group.partNumber}
                            variant={'outlined'}
                            sx={{
                                boxShadow: 'none',
                                backgroundColor: 'background.paper',
                                borderColor: 'divider',
                                paddingBlock: 1,
                                paddingInline: 1.5,
                            }}
                        >
                            <Typography variant={'body2'} color={'primary.main'}>{group.partNumber}</Typography>
                            {group.vendors.map(vendor => (
                                <Typography key={vendor.vendorCode} variant={'body2'} color={'text.primary'}>
                                    {t($ => $.removedVendorLine, {vendor: vendor.vendorCode, qty: vendor.qty})}
                                </Typography>
                            ))}
                        </Card>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions sx={{p: 0, m: 0, display: 'flex', justifyContent: 'space-between'}}>
                <Button
                    variant={'dialog'}
                    size={'medium'}
                    type={'button'}
                    color={'primary'}
                    borderRadius={'0 8px 0 8px'}
                    onClick={() => props.setOpen(false)}
                >
                    {t($ => $.close)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PurchasePlanningRemovedVendorsDialog;
